import { Appear } from "@components/motion/Appear"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useBlockContext } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Features Stack Inner Card",
}

export default defineBlock("section/features-stack-inner-card", (props) => {
  const info = useBlockContext()
  const index = info?.index || 0
  const hasIcon = info?.innerBlocks?.some((block) => block.blockName === "acf/content-inline-icon") || false

  return (
    <Appear
      delay={(index + 1) * 50}
      className={cn(
        "features-stack-inner-card w-full md:px-5 py-5 h-full text-pretty [&_p]:type-body-m-mobile [&_p]:text-grey-2 [&_p>strong]:text-charcoal",
        !env.admin && "flex flex-col gap-4",
        index % 3 < 2 && "first-two",
        index % 2 === 0 && "first",
        hasIcon && "[&_.wp-block-heading]:-mb-2",
      )}
    >
      <InnerBlocks
        allowedBlocks={["#inline"]}
        template={[
          ["content/inline-icon", {}],
          ["core/heading", { level: 5, placeholder: "Enter a title" }],
          ["core/paragraph", { placeholder: "Enter a description" }],
        ]}
      />
    </Appear>
  )
})
